import { createFileRoute } from '@tanstack/react-router'
import { GcDedupe } from '../components/gc-dedupe/GcDedupe'

export const Route = createFileRoute('/_a/gcDedupe')({
  component: GcDedupe,
})
